import { r, h as n, H as s, g as a } from "./main-bb89b2f2.js";
import "vue";
const o = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.static{position:static}", c = o, d = class {
  constructor(t) {
    r(this, t), this.disabled = !1, this.selected = !1, this.value = this.getItemId();
  }
  /**
   * Watcher for the selected property
   * @param newValue the new value of the selected property
   */
  valueWatcher(t) {
    t && this.dispatchSelectionEvent(), this.styleImage(t);
  }
  /**
   * Changes the style of the image if selected or normalizes it if unselected
   * @param selected true if the image is selected
   */
  styleImage(t) {
    let l, e;
    try {
      if (e = this.hostElement.parentElement, e.nodeName !== "PATTERNLIB-GALLERY-CAROUSEL")
        throw new Error("<patternlib-gallery-carousel-item> needs exactly one HTMLElement as a direct child and a <patternlib-gallery-carousel> as a parent");
      if (l = this.hostElement.children[0], l.getAttribute("style") == null)
        l.setAttribute("style", t ? e.activeElementStyle + ";" : e.inactiveElementStyle + ";");
      else if (!l.getAttribute("style").includes(e.inactiveElementStyle) && !l.getAttribute("style").includes(e.activeElementStyle)) {
        const i = l.getAttribute("style");
        l.setAttribute("style", t ? i + e.activeElementStyle + ";" : i + e.inactiveElementStyle + ";");
      } else {
        const i = t ? l.getAttribute("style").replace(e.inactiveElementStyle, e.activeElementStyle) : l.getAttribute("style").replace(e.activeElementStyle, e.inactiveElementStyle);
        l.setAttribute("style", i);
      }
    } catch {
      throw new Error("<patternlib-gallery-carousel-item> needs exactly one HTMLElement as a direct child and a <patternlib-gallery-carousel> as a parent");
    }
  }
  /**
   * Dispatches an event which can be captured by the parent gallery-carousel.
   */
  dispatchSelectionEvent() {
    this.hostElement.dispatchEvent(new CustomEvent("__lhInternalImageSelected", { bubbles: !0, detail: { value: this.value } }));
  }
  /**
   * Tries to get its own index inside of the parent patternlib-gallery-carousel element
   * If the parent is not a patternlib-gallery-carousel element, an error is thrown
   * @returns the calculated item id
   */
  getItemId() {
    var t;
    const l = (t = this.hostElement) === null || t === void 0 ? void 0 : t.parentElement, e = l == null ? void 0 : l.children;
    if (e != null) {
      for (let i = 0; i < e.length; i++)
        if (e[i] === this.hostElement)
          return i.toString();
    }
    throw new Error("<patternlib-gallery-item /> should only be used inside <patternlib-gallery />");
  }
  componentWillLoad() {
    this.styleImage(this.selected);
  }
  render() {
    const t = {
      selected: this.selected == !0,
      unselected: !0
    };
    return n(s, { key: "c71507fdb0dcc948e7e54edc9a3d5844c1339c7e", class: t, onClick: () => this.dispatchSelectionEvent(), style: { "scroll-snap-align": "center" } }, n("slot", { key: "c0eef8bae39fefb6769bb36e60d2400392ef2670" }));
  }
  get hostElement() {
    return a(this);
  }
  static get watchers() {
    return {
      selected: ["valueWatcher"]
    };
  }
};
d.style = c;
export {
  d as patternlib_gallery_carousel_item
};
